
import {  TiposDeDados } from "@/core/config/PerfisConfig";


class HoraAula {  


    public static campos = () => {
        return [   
            
            {
                nome: "escolaridade",
                type: "select",
                label: "Escolaridade",
                sm: 6 ,
                lg: 4, 
                disabled: false,
                options:  TiposDeDados.nivelEscolaridade() 
            }, 
            {
                nome: "valorInterno",
                type: "number",
                label: "Valor Interno",
                sm: 6 ,
                lg: 4, 
                disabled: false
            },   
            {
                nome: "valorExterno",
                type: "number",
                label: "Valor Externo",
                sm: 6 ,
                lg: 4, 
                disabled: false
            },   
 
            {
                nome: "docPublicacao",
                type: "text",
                label: "Documento Publicação",
                sm: 6 ,
                lg: 4, 
                disabled: false
            },   
            {
                nome: "inicio",
                type: "date",
                label: "Início Vigência",
                sm: 6 ,
                lg: 4, 
                disabled: false
            },  
            {
                nome: "fim",
                type: "date",
                label: "Fim da Vigência",
                sm: 6 ,
                lg: 4, 
                disabled: false
            },  
        ];
    }   
}
  
export   {   HoraAula };
